import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const UserRegisterContext = createContext();
export const ACTIONS = {
    SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
    SET_WEB_CONTENT_TEXT_TERMS: "SET_WEB_CONTENT_TEXT_TERMS",
    SET_WEB_CONTENT_TEXT_AUTH: "SET_WEB_CONTENT_TEXT_AUTH",
    SET_ALL_REGION:"SET_ALL_REGION",
    SET_COMUNA:"SET_COMUNA",
    SET_ID_REGION:"SET_ID_REGION",
    SET_FORM:"SET_FORM",
    SET_FORM_RESPONSE:"SET_FORM_RESPONSE",
    SET_RELATIONS:"SET_RELATIONS",
    SET_ID_CLIENT_VERIFY:"SET_ID_CLIENT_VERIFY",
    SET_ID_CLIENT_VERIFY_RESPONSE:"SET_ID_CLIENT_VERIFY_RESPONSE",
    SET_NUMBER_CLIENT_VERIFY:"SET_NUMBER_CLIENT_VERIFY",
    SET_RUT_VERIFY:"SET_RUT_VERIFY",
};

const initialState = {
    webContentTextInfo: null,
    webContentTextTerms: null,
    webContentTextAuth: null,
    allRegion: null,
    comuna: null,
    idRegion: null,
    form: null,
    formResponse: null,
    relations:"",
    idClientVerify:"",
    idClientVerifyResponse:"",
    numberClientVerify:"",
    rutVerify:""

};
const UserRegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_NUMBER_CLIENT_VERIFY: {
      return {
        ...state,
        numberClientVerify: action.payload,
      };
    }
    case ACTIONS.SET_RUT_VERIFY: {
      return {
        ...state,
        rutVerify: action.payload,
      };
    }
    case ACTIONS.SET_ID_CLIENT_VERIFY_RESPONSE: {
      return {
        ...state,
        idClientVerifyResponse: action.payload,
      };
    }
    case ACTIONS.SET_ID_CLIENT_VERIFY: {
      return {
        ...state,
        idClientVerify: action.payload,
      };
    }
    case ACTIONS.SET_FORM: {
      return {
        ...state,
        form: action.payload,
      };
    }
    case ACTIONS.SET_FORM_RESPONSE: {
      return {
        ...state,
        formResponse: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_TERMS: {
      return {
        ...state,
        webContentTextTerms: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_AUTH: {
      return {
        ...state,
        webContentTextAuth: action.payload,
      };
    }
    case ACTIONS.SET_COMUNA: {
        return {
            ...state,
            comuna: action.payload
        };
    }
    case ACTIONS.SET_ALL_REGION: {
        return {
            ...state,
            allRegion: action.payload
        };
    }
    case ACTIONS.SET_ID_REGION: {
        return {
            ...state,
            idRegion: action.payload
        };
    } 
    case ACTIONS.SET_COMUNA_REGION: {
        return {
            ...state,
            comunaRegion: action.payload
        };
    }
    case ACTIONS.SET_RELATIONS: {
      return {
        ...state,
        relations: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const UserRegisterContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(UserRegisterReducer, initialState);

  useEffect(() => {

    if (state.rutVerify && state.numberClientVerify) {
        LiferayService.checkIfCanRegisterNewUserWithRutAndAccount(properties.base_url_api, state.rutVerify, state.numberClientVerify)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_ID_CLIENT_VERIFY_RESPONSE,
            });
            dispatch({
              payload: "",
              type: ACTIONS.SET_RUT_VERIFY,
            });
            dispatch({
              payload: "",
              type: ACTIONS.SET_NUMBER_CLIENT_VERIFY,
            });
          })
    }

  }, [state.rutVerify, state.numberClientVerify]);
  
  useEffect(() => {

    if (properties?.webcontent_info_page_user_register?.trim()) {
        LiferayService.getWebContent(properties.base_url_api, properties?.webcontent_info_page_user_register?.trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
    }

    if (properties?.webcontent_terms_page_user_register?.trim()) {
        LiferayService.getWebContent(properties.base_url_api, properties?.webcontent_terms_page_user_register?.trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_TERMS,
            });
          })
    }

    if (properties?.webcontent_auth_page_user_register?.trim()) {
        LiferayService.getWebContent(properties.base_url_api, properties?.webcontent_auth_page_user_register?.trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_AUTH,
            });
          })
    }

    LiferayService.getAllRegions(properties.base_url_api)
    .then((response) =>{
        dispatch({
            payload: response,
            type: ACTIONS.SET_ALL_REGION,
        });
        dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
        });
        })
    .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
    })

    LiferayService.getAllComunas(properties.base_url_api)
    .then((response) =>{
        dispatch({
            payload: response,
            type: ACTIONS.SET_COMUNA,
        });
        dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
        });
        })
    .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
    })

    LiferayService.getRelationctacto(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_RELATIONS,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
    })

  }, []);

  useEffect(() => {
      if(state.idRegion){
          LiferayService.getComunasFromRegion(properties.base_url_api, state.idRegion)
          .then((response) =>{
              dispatch({
                  payload: response,
                  type: ACTIONS.SET_COMUNA_REGION,
              });
              dispatch({
                  payload: null,
                  type: ACTIONS.SET_ERROR,
              });
          })
          .catch((error) => {
              dispatch({
              payload: error,
              type: ACTIONS.SET_ERROR,
              });
          })
      }
  }, [state.idRegion])

  useEffect(() => {
      if(state.form){
          LiferayService.createNewUser(properties.base_url_api, state.form,properties.codigo_empresa)
          .then((response) =>{
              dispatch({
                  payload: response,
                  type: ACTIONS.SET_FORM_RESPONSE,
              });
              dispatch({
                  payload: null,
                  type: ACTIONS.SET_FORM,
              });
              dispatch({
                  payload: null,
                  type: ACTIONS.SET_ERROR,
              });
          })
          .catch((error) => {
              dispatch({
              payload: error,
              type: ACTIONS.SET_ERROR,
              });
          })
      }
  }, [state.form])
  
  return (
    <UserRegisterContext.Provider value={[state, dispatch]}>
      {children}
    </UserRegisterContext.Provider>
  );
};
export default UserRegisterContextProvider;
